<template>
  <div>
    <h1>Info Page</h1>
    <v-layout>
      <v-text-field v-model="title" solo label="Title"></v-text-field>
      <v-select
        style="margin-left: 10px;"
        label="isDoctor"
        v-model="isDoctor"
        :items="[
          {
            value: '0',
            label: 'Patient',
          },
          {
            value: '1',
            label: 'Doctor',
          },
          
        ]"
        item-text="label"
        item-value="value"
      ></v-select>
    </v-layout>
    <v-layout>
      <v-textarea
          v-model="description"
          solo
          label="Description"
          auto-grow
          rows="3"
        ></v-textarea>
      <v-btn :disabled="(title != null && title != '' && description != null && description != '' && isDoctor != null && isDoctor != '') ? false : true" @click="createInfo" text
        color="success">add new info</v-btn>
    </v-layout>
    <v-layout>
      <v-text-field @input="seatchMethod" v-model="search" solo label="Search"></v-text-field>
    </v-layout>
    <v-layout v-if="info != null">
      <v-data-table v-if="info.length" :headers="[
        { text: 'Title', value: 'title' },
        { text: 'isDoctor', value: 'check_type' },
        { text: 'EDIT', value: 'edit' },
        { text: 'DELETE', value: 'actions' },


      ]" :items="filteredInfo">
        <template v-slot:item.actions="{ item }">
          <v-btn @click="deleteItem(item)" text color="error">DELETE</v-btn>
        </template>
        <template v-slot:item.check_type="{ item }">
          {{ item.isDoctor == 1 ? 'Doctor' : 'Patient' }}
        </template>
        <template v-slot:item.edit="{ item }">
          <v-btn @click="edit(item)" text color="info">Edit</v-btn>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog" v-if="selected != null" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Updating
          </v-card-title>

          <v-card-text>
            <v-text-field v-model="selected.title" label="Title"></v-text-field>
            <v-select
            label="isDoctor"
            v-model="selected.isDoctor"
            :items="[
              {
                value: '0',
                label: 'Patient',
              },
              {
                value: '1',
                label: 'Doctor',
              },
              
            ]"
            item-text="label"
            item-value="value"
          ></v-select>
          </v-card-text>
          <v-card-text>
            <v-textarea
              v-model="selected.description"
              solo
              label="Description"
              auto-grow
              rows="3"
            ></v-textarea>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" flat @click="update">
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios';
import CryptoJS from "crypto-js";
import { Base64 } from 'js-base64';
export default {
  data() {
    return {
      title: null,
      isDoctor:null,
      description: null,
      info: null,
      filteredInfo: null,
      search: '',
      selected: null,
      user:'',
      users:null,
      dialog: false,
      loading:{
        img:false,
        video:false
      }
    }
  },
  methods: {
    encryptObject(data) {
      const key = CryptoJS.enc.Utf8.parse(process.env['VUE_APP_SECURE_KEY']);
      const iv = CryptoJS.lib.WordArray.random(16);
      const ivBase64 = CryptoJS.enc.Base64.stringify(iv);

      const objectToEncryptString = JSON.stringify(data);

      const encrypted = CryptoJS.AES.encrypt(objectToEncryptString, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        keySize: 256 / 8,
      });

      const encryptedObject = {
        iv: ivBase64,
        value: encrypted.ciphertext.toString(CryptoJS.enc.Base64),
      };
      return encryptedObject;
    },
    decryptData(res) {
      var key = process.env["VUE_APP_SECURE_KEY"];
      var encrypted = res.payload;
      var encrypted_json = JSON.parse(Base64.decode(encrypted));
      var decrypted = CryptoJS.AES.decrypt(encrypted_json.value, CryptoJS.enc.Base64.parse(Base64.encode(key)), {
        iv: CryptoJS.enc.Base64.parse(encrypted_json.iv),
        mode: CryptoJS.mode.CBC
      });
      let data = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

      return data;
    },
    async update() {
      if (this.selected.title != null && this.selected.title != "")
        await axios
          .post("/info-page/update", {
            info_id: this.selected.id,
            title: this.selected.title,
            isDoctor: this.selected.isDoctor,
            description: this.selected.description,
          }).then((res) => {
            this.dialog = false;
            this.sync();
          })
    },
    edit(item) {
      this.selected = Object.assign({}, item);
      this.dialog = true;
    },
    seatchMethod(val) {
      if (this.search == '') {
        this.filteredInfo = this.info;
      }
      else {
        this.filteredInfo = this.info.filter(element => {
          return (element.title).includes(this.search)
        });
      }
    },
    async createInfo() {
      if (this.title != null && this.title != "")
        await axios
          .post("/info-page/store", {
            title: this.title,
            description: this.description,
            isDoctor: this.isDoctor
          }).then(() => {
            this.sync();
            this.title = null;
            this.description = null;
            this.isDoctor = null;
          })
    },
    async deleteItem(item) {
      await axios
        .post("/info-page/delete", item).then(() => {
          this.sync();
        })
    },
    async sync() {
      await axios
        .get("/info-page/get").then((res) => {
          this.info = res.data.data;
          this.filteredInfo = res.data.data;
        })
    },
  },
  created() {
    this.sync();
  }
}
</script>
<style lang="scss" scoped></style>